import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as dd from 'dingtalk-jsapi';
import moment from 'moment'
import './http'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.prototype.$dd = dd
Vue.config.productionTip = false

Vue.filter('time', time => {
  return moment(time).format("YYYY-MM-DD HH:mm:ss")
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
